import React from 'react';
import { Card, CardContent, CardHeader, IconButton, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import { Event, MoreVert } from '@material-ui/icons';
import { SimovsatAlert } from '~/types';

interface AlertsCardProps {
  alerts: SimovsatAlert[];
}

export default function AlertsCard({ alerts }: AlertsCardProps) {
  return (
    <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Event />
            <Typography variant='h6' style={{ fontWeight: 'bold' }}>
              ALERTAS
            </Typography>
          </div>
        }
        action={
          <IconButton size='small'>
            <MoreVert />
          </IconButton>
        }
        style={{ backgroundColor: '#f5f5f5', padding: '12px 16px' }}
      />
      <CardContent style={{ flex: 1, overflow: 'auto', padding: 0 }}>
        <List style={{ maxHeight: 400, overflow: 'auto' }}>
          {alerts.map((alert, index) => (
            <ListItem key={index} divider>
              <ListItemText
                primary={alert.tipo}
                secondary={`${alert.quantidade} Vezes`}
                primaryTypographyProps={{ style: { fontSize: '14px' } }}
                secondaryTypographyProps={{ style: { fontSize: '12px', color: '#666' } }}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
